import { Outlet, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@/hooks/use-auth'
import { AppShell, BackofficeHeader, BackofficeSidebar } from '@betstarters/ui'
import {
  LayoutDashboard, Globe, Languages, Landmark, CreditCard, FileText, Scale,
  Building, Wallet, Clock, Package, Shield, Tags,
} from 'lucide-react'

export function SiteBuilderAppShell() {
  const { t } = useTranslation()
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const role = user?.platform_role ?? ''
  const isPlatformAdmin = role === 'PLATFORM_ADMIN'

  const sections = [
    {
      label: t('nav.main', { defaultValue: 'Main' }),
      items: [
        { to: '/', icon: LayoutDashboard, label: t('nav.dashboard', { defaultValue: 'Dashboard' }) },
        { to: '/sites', icon: Tags, label: t('nav.sites', { defaultValue: 'Sites' }) },
      ],
    },
    {
      label: t('nav.catalogs', { defaultValue: 'Platform Catalogs' }),
      items: [
        { to: '/catalogs/countries', icon: Globe, label: t('nav.countries', { defaultValue: 'Countries' }), visible: isPlatformAdmin },
        { to: '/catalogs/currencies', icon: Wallet, label: t('nav.currencies', { defaultValue: 'Currencies' }), visible: isPlatformAdmin },
        { to: '/catalogs/languages', icon: Languages, label: t('nav.languages', { defaultValue: 'Languages' }), visible: isPlatformAdmin },
        { to: '/catalogs/document-types', icon: FileText, label: t('nav.documentTypes', { defaultValue: 'Document Types' }), visible: isPlatformAdmin },
        { to: '/catalogs/jurisdictions', icon: Scale, label: t('nav.jurisdictions', { defaultValue: 'Gaming Jurisdictions' }), visible: isPlatformAdmin },
        { to: '/catalogs/banks', icon: Landmark, label: t('nav.banks', { defaultValue: 'Banks' }), visible: isPlatformAdmin },
        { to: '/catalogs/payment-methods', icon: CreditCard, label: t('nav.paymentMethods', { defaultValue: 'Payment Methods' }), visible: isPlatformAdmin },
        { to: '/catalogs/account-formats', icon: Building, label: t('nav.accountFormats', { defaultValue: 'Account Formats' }), visible: isPlatformAdmin },
        { to: '/catalogs/timezones', icon: Clock, label: t('nav.timezones', { defaultValue: 'Timezones' }), visible: isPlatformAdmin },
        { to: '/catalogs/products', icon: Package, label: t('nav.products', { defaultValue: 'Products' }), visible: isPlatformAdmin },
        { to: '/catalogs/roles', icon: Shield, label: t('nav.roles', { defaultValue: 'Roles & Permissions' }), visible: isPlatformAdmin },
      ],
    },
  ]

  const sidebar = (
    <BackofficeSidebar
      subtitle="Site Builder"
      sections={sections}
    />
  )

  const header = (
    <BackofficeHeader
      userEmail={user?.email}
      userRole={user?.platform_role}
      onLogout={logout}
      onProfileClick={() => navigate('/profile')}
      showLanguageSwitcher
    />
  )

  return (
    <AppShell sidebar={sidebar} header={header}>
      <Outlet />
    </AppShell>
  )
}
